import api from '@/services/api';

export default {
    storePromotion({ commit }) {
        commit('WAIT_DATA_TO_BE_LOADED');

        api.get('/api/active_promotion')
            .then((response) => {
                commit('STORE_PROMOTION', response.data.body.promotion);
            });
    },
};
